<template>

    <div class="row">
        <div v-for="(options, slug, idx) in spatialHierarchy" :key="idx" class="col-12 col-sm-6 col-md-4">
            <div class="form-group">
                <label :for="slug" class="form-label">{{ slug }}</label>
                <v-select
                    :disabled="isSelectDisabled(idx, slug)"
                    :name="slug"
                    label="name"
                    :options="options"
                    placeholder="All"
                    v-model="selected[slug]"
                    :resetOnOptionsChange="false"
                    @input="loadUnits($event, slug)"
                    />
            </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
           <center> <p class="alert alert-info mt-0 mb-2 pt-2 pb-2" style=""> Selected: {{ currentlySelected.name }}</p> </center>
           <center> <button type="button" @click="click" class="btn btn-update">{{buttonText}}</button> </center>
        </div>
    </div>

</template>

<script>

export default {

    props: {
        buttonText: {
            type: String,
            default: 'Search',
        },
        
        // used to disable possible selections
        targetSlug: {
            type: String,
            default: 'village',
        },

    },

    data() {

        return {

            filterUrl: window.APP_URL + "/spatial/filter/",

            selected: {
                'province': null,
                'district': null,
                'sector': null,
                'cell': null,
                'village': null,
            },

            spatialHierarchy: {
                'province': [],
                'district': [],
                'sector': [],
                'cell': [],
                'village': [],
            },

            currentlySelected: { name: 'Nation' },
        };

    },

    computed: {

    },

    mounted() {

        window.axios.get(this.filterUrl + 'province')
            .then((response) => {
                this.spatialHierarchy.province = response.data;
            })
            .catch(error => {
                window.alert(error);
            });
    },

    methods: {

        click()
        {
            this.$emit('click', this.currentlySelected);
        },

        setCurrentlySelected(evt, slug) {

            let hierarchy = this.getHierarchy();

            // find first one with null
            let nullSlug = hierarchy.find(slug => {

                if (this.selected.hasOwnProperty(slug))
                {
                    let condition = this.selected[slug] === null;
                    return condition;
                }

                return false;
            });

            // if province cleared
            if (this.getIndexBySlug(nullSlug) === 0)
            {
                this.currentlySelected = { name: 'Nation' };
                this.clearAllBelowHierarchy(nullSlug);
                this.spatialHierarchy['district'] = [];
                return;

            }

            // if village was cleared
            if (slug === 'village' && evt !== null)
            {
                this.currentlySelected = this.selected[slug];
                return;
            }

            // find slug what is one above and clear the rest
            slug = this.getPrevousSlugInHierarchy(nullSlug);
            this.currentlySelected = this.selected[slug];
            this.clearAllBelowHierarchy(slug);
        },

        getUnitsQueryUrl(slug, id) {

            if (slug && id)
            {
                let targetSlug = this.getNextSlugInHierarchy(slug);
                return this.filterUrl + slug + '/' + id + '/' + targetSlug;
            }

        },

        isSelectDisabled(idx, slug)
        {
            return this.isBelowHierarchy(slug, this.targetSlug);
        },

        loadUnits(event, slug)
        {

            this.clearAllBelowHierarchy(slug);
            this.setCurrentlySelected(event, slug);

            // input event fires even if value is changed through script
            // v-select is the worst component in vue.js that has ever existed
            if (event === null)
                return;

            if (slug == "village")
                return;
           
            window.axios.get(this.getUnitsQueryUrl(this.currentlySelected.slug, this.currentlySelected.id))
                .then((response) => {
                    let index = this.getIndexBySlug(this.currentlySelected.slug);
                    this.spatialHierarchy[this.getSlugByIndex(index + 1)] = response.data;
                })
                .catch(error => {
                    window.alert(error);
                });
        },

        clearAllBelowHierarchy(slug)
        {
            let hierarchy = this.getHierarchy();
           
            hierarchy.forEach(hierarchySlug => {

                if (this.isBelowHierarchy(hierarchySlug, slug))
                {
                    this.selected[hierarchySlug] = null;
                    let nxtSlug = this.getNextSlugInHierarchy(hierarchySlug);
                    
                    if (nxtSlug)
                        this.spatialHierarchy[nxtSlug] = [];
                }
            });
        },

        clearAllButProvince()
        {
            let hierarchy = this.getHierarchy();

            hierarchy.forEach(hierarchySlug => {

                if(hierarchySlug == 'province')
                    return;

                this.selected[hierarchySlug] = null;
                this.spatialHierarchy[hierarchySlug] = null;
            });
        },
        
        isAboveHierarchy(slug1, slug2)
        {
            if (!this.spatialHierarchy.hasOwnProperty(slug1)) {
                return true;
            }
 
            let selectIndex = this.getIndexBySlug(slug1);
            let targetIndex = this.getIndexBySlug(slug2);

            return targetIndex > selectIndex;
        },

        isBelowHierarchy(slug1, slug2)
        {
            if (!this.spatialHierarchy.hasOwnProperty(slug2)) {
                return false;
            }
 
            let selectIndex = this.getIndexBySlug(slug1);
            let targetIndex = this.getIndexBySlug(slug2);

            return targetIndex < selectIndex;
        },

        getNextSlugInHierarchy(slug)
        {
            let index = this.getIndexBySlug(slug);
            return this.getSlugByIndex(index + 1);
        },

        getPrevousSlugInHierarchy(slug)
        {
            let index = this.getIndexBySlug(slug);
            return this.getSlugByIndex(index -1);
        },

        getSlugByIndex(idx)
        {
            let hierarchy = this.getHierarchy();
            return hierarchy[idx];
        },

        getIndexBySlug(slug)
        {
            let index = this.getHierarchy().indexOf(slug);
            return index;
        },

        getHierarchy()
        {
            // if order changes replace with seperate array
            return Object.keys(this.spatialHierarchy);
        },
    },

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/filters/AdminUnitSpatialFilter.vue